<template>
  <div>
    <div class="bg-white py-6">
      <!-- Replace with your content -->
      <div>
        <div class="md:flex md:items-center md:justify-between sm:px-6 md:px-8">
          <div class="flex-1 min-w-0">
            <h2 class="text-2xl font-bold leading-7 text-gray-800 sm:text-3xl sm:truncate">
              {{ $t("messages.approveTopup.approveTopup") }}
            </h2>
          </div>
          <div class="mt-4 flex-shrink-0 flex md:mt-0 md:ml-4"></div>
        </div>
      </div>
    </div>
    <!-- /End replace -->

    <nav class="bg-white border-b border-t border-gray-200 flex" aria-label="Breadcrumb">
      <ol class="w-full mx-auto px-4 flex space-x-4 sm:px-6 md:px-8">
        <li class="flex">
          <div class="flex items-center">
            <a href="javascript:void(0)" class="text-gray-400 hover:text-gray-500">
              <!-- <HomeIcon class="flex-shrink-0 h-5 w-5" aria-hidden="true" /> -->
              <span class="sr-only">Home</span>
            </a>
          </div>
        </li>
        <li v-for="page in pages" :key="page.name" class="flex">
          <div class="flex items-center">
            <svg
              class="flex-shrink-0 w-6 h-full text-gray-200"
              viewBox="0 0 24 44"
              preserveAspectRatio="none"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
            </svg>
            <router-link
              :to="page.href"
              class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
              :aria-current="page.current ? 'page' : undefined"
              >{{ page.name }}</router-link
            >
          </div>
        </li>
      </ol>
    </nav>

    <div class="">
      <div class="space-y-8 divide-y divide-gray-200 bg-white py-3 border-b text-center overflow-x-auto">
        <div class="md:flex md:items-center md:justify-between">
          <div class="flex-1 px-2 flex md:flex-row flex-col justify-center lg:ml-6 lg:justify-start mx-auto">
            <div class="max-w-lg w-full md:w-64 lg:max-w-xs">
              <div class="relative text-gray-600 focus-within:text-gray-600">
                <div class="pointer-events-none absolute inset-y-0 pl-1 left-0 flex items-center">
                  {{ $t("messages.approveTopup.from") }}:
                </div>
                <input
                  id="from"
                  v-model="fromDate"
                  maxlength="10"
                  @change="search($event)"
                  class="block w-full bg-white py-2 pl-14 focus:bg-white pr-1 border border-transparent rounded-md leading-5 text-gray-900 placeholder-gray-500 focus:ring-offset-blue-600 focus:ring-white focus:border-white sm:text-sm"
                  placeholder="From"
                  type="date"
                  name="from"
                />
              </div>
            </div>
            <div class="max-w-lg w-full md:w-64 lg:max-w-xs">
              <div class="relative text-gray-600 focus-within:text-gray-600">
                <div class="pointer-events-none absolute inset-y-0 pl-1 left-0 flex items-center">
                  {{ $t("messages.approveTopup.to") }}:
                </div>
                <input
                  id="from"
                  v-model="toDate"
                  maxlength="10"
                  @change="search($event)"
                  class="block w-full bg-white py-2 pl-14 focus:bg-white pr-1 border border-transparent rounded-md leading-5 text-gray-900 placeholder-gray-500 focus:ring-offset-blue-600 focus:ring-white focus:border-white sm:text-sm"
                  placeholder="To"
                  type="date"
                  name="to"
                />
              </div>
            </div>
          </div>

          <div class="flex items-center md:mr-5 gap-5 justify-center">
            <div class="flex items-center md:mr-5">
              {{ $t("messages.approveTopup.notification") }}:
              <!-- {{
              userRoles
                ? userRoles.toString()
                : "-"
            }} -->
              <Switch
                style="height: 20px; width: 40px"
                :v-model="isNotified"
                @click="updateNotification()"
                :class="isNotified ? 'bg-blue-500' : 'bg-red-900'"
                class="ml-3 relative inline-flex flex-shrink-0 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75"
              >
                <span
                  style="width: 16px; height: 16px"
                  :class="isNotified ? 'translate-x-5' : 'translate-x-0'"
                  class="pointer-events-none inline-block rounded-full bg-white shadow-lg transform ring-0 transition ease-in-out duration-200"
                />
              </Switch>
            </div>
            <select v-if="payments.length > 1" class="rounded" v-model="selected_payment" @change="changePayment">
              <option v-for="(payment, index) in payments" :value="payment" :key="index">
                {{ payment }}
              </option>
            </select>
            <div v-else>{{ selected_payment }}</div>
          </div>
          <div class="mt-4 flex-shrink-0 flex md:mt-0 md:ml-4 pr-8">
            <!-- <button
              type="button"
              class="ml-3 inline-flex items-center px-3 py-1 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500"
            >
              <font-awesome-icon
                class="text-white mr-2"
                :icon="['far', 'filter']"
                transform=""
              />
              Advance Filter
            </button> -->
          </div>
        </div>
      </div>
    </div>

    <div class="px-8 py-6" v-show="!isLoaded">
      <div class="space-y-8 divide-y divide-gray-200 bg-white px-10 py-9 rounded-md shadow-md text-center">
        <font-awesome-icon class="text-gray-500" :icon="['fas', 'circle-notch']" transform="grow-6" spin />
      </div>
    </div>

    <div class="py-6" v-if="isLoaded">
      <div class="sm:px-6 md:px-8">
        <div class="sm:block overflow-x-auto">
          <nav class="flex space-x-8">
            <div
              @click="onTabClicked(tab.name)"
              v-for="(tab, index) in tabs"
              :key="tab.name"
              :class="[
                selectedTab == tab.name
                  ? 'border-blue-500 text-blue-600 '
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
                'whitespace-nowrap pb-4 px-1 border-b-2 font-medium text-sm',
              ]"
              :aria-current="tab.current ? 'page' : undefined"
              :style="selected_payment !== 'RTB' && index === 1 ? 'display:none' : null"
            >
              {{ $t(`messages.approveTopup.${tab.name.toLocaleLowerCase().split(" ").join("")}`) }}
            </div>
          </nav>
        </div>
      </div>
      <div class="sm:px-6 md:px-8 my-5">
        <deposit-tab
          v-if="selectedTab === 'Payment'"
          :dataRows="dataRows"
          :selected_payment="selected_payment"
          :count="dataCount"
          :totalPages="totalPages"
          @onSubmit="refetch"
          @onRefetchData="onRefetchData"
          :currentPage="currentPage"
        ></deposit-tab>
        <manual-tab v-if="selectedTab === 'Manual Deposit'" :start_date="fromDate" :end_date="toDate" />
      </div>
    </div>
  </div>
</template>

<script>
import { inject, onMounted, ref } from "@vue/runtime-core";
import { useStore } from "vuex";
import * as dayjs from "dayjs";
import "dayjs/locale/th";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { useRoute, useRouter } from "vue-router";
import DepositTab from "./approvePayment-tabs/DepositTab.vue";
import ManualTab from "./approvePayment-tabs/ManualTab.vue";
import { Switch } from "@headlessui/vue";

dayjs.extend(localizedFormat);

const rowsPerPageOption = [
  { label: "2", value: 2 },
  { label: "5", value: 5 },
  { label: "10", value: 10 },
  { label: "20", value: 20 },
  { label: "30", value: 30 },
  { label: "40", value: 40 },
];

const pages = [{ name: "Approve Topup", href: "", current: true }];

export default {
  components: {
    DepositTab,
    ManualTab,
    Switch,
  },
  setup() {
    const axios = inject("$axios");
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const fromDate = ref("");
    const toDate = ref("");
    let approveModalOpen = ref(false);
    let dataRows = ref([]);
    let dataCount = ref(0);
    let isLoaded = ref(false);
    const isWorking = ref(false);
    const selected = ref({});
    let errorMessage = ref({});
    let hasError = ref(false);
    let payments = ref(["PAYDUTY", "RTB"]);

    const totalPages = ref(1);

    const currentPage = ref(1);
    const rowsPerPage = ref({ label: "10", value: 10 });
    const offset = ref(0);

    const selectedTab = ref("Payment");
    const isNotified = ref(store.state.user.topupNotification);

    let tabs = ref([
      {
        name: "Payment",
        href: { name: "Wallet Info", params: { id: route.params.id } },
        route: "Wallet Info",
      },
      {
        name: "Manual Deposit",
        href: { name: "Player Bet Limit", params: { id: route.params.id } },
        route: "Player Bet Limit",
      },
    ]);

    const onTabClicked = (name) => {
      selectedTab.value = name;
    };

    const updateNotification = () => {
      const notification = isNotified.value ? false : true;
      isNotified.value = notification;
      store.commit("serUserTopupNotification", notification);
    };

    const selected_payment = ref();

    onMounted(() => {
      if (store.state.user.payment) selected_payment.value = store.state.user.payment;
      else selected_payment.value = payments.value[0];

      // console.log('selected_payment.value', selected_payment.value);
      refetch();
      // setTimeout(() => {
      //   refetch();
      // }, 60000);
    });

    const refetch = () => {
      if (selected_payment.value == "RTB") {
        changePayment(selected_payment.value);
      } else {
        axios
          .get(
            process.env.VUE_APP_API_ENDPOINT +
              "/admin/api/v1/transactions/pending/deposit/" +
              store.state.selectedOperator.operatorId
          )
          .then(({ data }) => {
            if (data.list) {
              dataRows.value = data.list;
            } else {
              dataRows.value = [];
            }

            dataCount.value = data.total_records;
            isLoaded.value = true;
          })
          .catch(({ response }) => {
            dataRows.value = [];
            // alert("ไม่มีข้อมูลที่สามารถแสดงได้");
            isLoaded.value = true;
            console.log(response);
          });
      }
    };

    const getLocaleDate = (date) => {
      return dayjs(date).locale("th").format("LLL");
    };

    const onRefetchData = (page) => {
      currentPage.value = page;
      refetch();
    };

    const changePayment = (payment) => {
      selectedTab.value = "Payment";
      if (payment.target?.value) store.commit("setUserPayment", payment.target?.value);

      if (payment == "RTB") {
        isLoaded.value = false;
        axios
          .get(
            `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/internal/rtb/internal/deposits/pending-list/${store.state.selectedOperator.operatorId}?page=${currentPage.value}`
          )
          .then(({ data }) => {
            // console.log(data)
            if (data) {
              build(data);
              totalPages.value = data.totalPages;
              dataCount.value = data.totalResults;
              isLoaded.value = true;
            } else {
              dataRows.value = [];
              dataCount.value = 0;
            }
          })
          .catch((err) => {
            dataRows.value = [];
            dataCount.value = 0;
            isLoaded.value = true;
          });
      } else {
        refetch();
      }
    };

    const pageCount = () => {
      return Math.ceil(dataCount.value / rowsPerPage.value.value);
    };

    const jump = (page) => {
      currentPage.value = page;
      offset.value = (page - 1) * rowsPerPage.value.value;
      refetch();
    };

    const build = (data) => {
      let returner = [];
      for (let i = 0; i < data.results.length; i++) {
        returner.push({
          deposit_id: data.results[i].id,
          deposit_amount: data.results[i].amount.toFixed(2),
          txnRemark: data.results[i].txnRemark,
          remark: data.results[i].remark,
          bank_code: data.results[i].bank ? data.results[i].bank.code : data.results[i].bankId,
          bank: data.results[i].bank.bankName ? data.results[i].bank.bankName : "-",
          bank_name: data.results[i].member ? data.results[i].member.bankAccountName : "-",
          bank_no: data.results[i].member ? data.results[i].member.bankAccountNumber : "-",
          createdate: data.results[i].createdAt,
          member_id: data.results[i].memberId,
          deposit_datetime: data.results[i].dateTime,
        });
      }

      dataRows.value = returner;
    };

    const search = (e) => {
      let from = dayjs(fromDate.value);
      let to = dayjs(toDate.value);

      if (
        (e.code == "Enter" || e.code == "NumpadEnter" || e.type == "change" || e.keyCode == 13) &&
        from.isValid() &&
        to.isValid() &&
        from.isBefore(to)
      ) {
        isLoaded.value = false;
        axios
          .get(
            process.env.VUE_APP_API_ENDPOINT +
              "/admin/api/v1/transactions/pending/deposit/" +
              store.state.selectedOperator.operatorId
          )
          .then(({ data }) => {
            if (data.result.data.length == 1) {
              router.push({
                name: "Wallet Info",
                params: { id: data.result.data[0].id },
              });
              return;
            }

            dataRows.value = data.list;
            dataCount.value = data.total_records;
            isLoaded.value = true;
          })
          .catch((err) => {
            console.log(err);
            isLoaded.value = true;
          });
      }
    };

    const prev = () => {
      if (currentPage.value - 1 >= 1) {
        currentPage.value -= 1;
        offset.value = (currentPage.value - 1) * rowsPerPage.value.value;
        refetch();
      }
    };

    const next = () => {
      if (currentPage.value + 1 <= pageCount()) {
        offset.value = rowsPerPage.value.value * currentPage.value;

        refetch();
        currentPage.value += 1;
      }
    };

    return {
      totalPages,
      dataRows,
      dataCount,
      isLoaded,
      dayjs,
      fromDate,
      toDate,
      route,
      prev,
      next,
      search,
      getLocaleDate,
      pages,
      isWorking,
      selected_payment,
      payments,
      changePayment,
      errorMessage,
      hasError,
      tabs,
      selectedTab,
      onTabClicked,
      refetch,
      onRefetchData,
      currentPage,
      updateNotification,
      isNotified,
    };
  },
};
</script>
